import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { createApiClient } from 'src/lib/api-client'

const resendAuthCodeByVoice = async ({
  trialUid,
  explanationSignAuthUid,
}: {
  trialUid: string
  explanationSignAuthUid: string
}) => {
  const res = await createApiClient({
    path: '/explanation_sign_authentication/trials/{trial_uid}/{explanation_sign_authentication_uid}/resend_by_voice',
    httpMethod: 'post',
    params: {
      paths: {
        trial_uid: trialUid,
        explanation_sign_authentication_uid: explanationSignAuthUid,
      },
    },
  }).request()

  if (res.result === 'error') {
    throw new Error(res.error.data.message)
  }
}

export const useResendAuthCodeByVoice = (option?: UseMutationOption<void>) => {
  return useMutation(
    ({
      trialUid,
      explanationSignAuthUid,
    }: {
      trialUid: string
      explanationSignAuthUid: string
    }) => resendAuthCodeByVoice({ trialUid, explanationSignAuthUid }),
    option,
  )
}
